import { render } from "./ModalBootstrap.vue?vue&type=template&id=6d931337&scoped=true"
import script from "./ModalBootstrap.vue?vue&type=script&lang=js"
export * from "./ModalBootstrap.vue?vue&type=script&lang=js"

import "./ModalBootstrap.vue?vue&type=style&index=0&id=6d931337&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d931337"]])

export default __exports__